import script from "./CustomModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomModal.vue?vue&type=style&index=0&id=eaf9beee&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaf9beee"]])

export default __exports__